// extracted by mini-css-extract-plugin
export default {"root":"TariffListCardInfoBlock__root--2cvKs"};